import React, { useState } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Loader from '../../component/Loader.js';


const ExamReg = () => {
    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/")
    }

    const { http } = Api();

    const [examid, setExamIdData] = useState('');

    const [getexamData, setExamData] = useState([]);

    const [isDownloading, setIsDownloading] = useState(false)


    const handlExamChange = (selectedOption) => {
        setExamIdData(selectedOption.value);
    };

    useEffect(() => {
        const fetchExamData = async () => {
            try {
                const response = await http.get(`/Student/getAtiveExam`);

                // console.log("response", response.data);
                setExamData(response.data);
            }
            catch (error) {
                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No active exam found");
                }
                else {
                    toast.error("Something went wrong");
                }
            }
        };

        fetchExamData();
    }, []);

    const handleGeneratePDFNew = async () => {

        setIsDownloading(true)

        try {
            const response = await http.get('/generateApplicationFormPdf', {
                params: {
                    examid: examid,
                },
                responseType: 'blob',

            });

            if (response && response.data) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${localStorage.getItem('user')}-Exam-Registration.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsDownloading(false);
                return Promise.resolve('PDF generated successfully ');

            }

        } catch (error) {
            console.log("error", error);

            if (error.response?.data instanceof Blob) {
                // Parse blob into JSON
                error.response.data.text().then(text => {
                    try {
                        const json = JSON.parse(text);

                        if (json.status_code === "ERR66") {
                            toast.error(json.message);
                        } else {
                            toast.error("Something went wrong");
                        }
                    } catch (e) {
                        toast.error("Unexpected error format");
                    }
                });
            } else {
                // Fallback normal JSON case
                if (error.response?.data?.status_code === "ERR66" && error.response?.data?.http_status === 500) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error("Something went wrong");
                }
            }

            setIsDownloading(false);
            return Promise.resolve(); 
            //return Promise.reject('Error generating PDF');
        }
    };




    return (
        <>
            <StudentTemplate>
                <ToastContainer />


                {isDownloading ? (

                    <Loader />

                ) : (
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-12 col-lg-12">
                                <div className="card shadow-lg border-0 mobile">


                                    <div className="card-body">
                                        <h3 className="card-title text-center mb-4 font-weight-bold text-black mobile">

                                            Exam Registration Form
                                        </h3>

                                        <p className="text-center text-muted mb-5 mobile">
                                            Select your exam and click the download button to get started.
                                        </p>
                                        <div className="mb-4">
                                            <Select
                                                maxMenuHeight={200}
                                                menuPlacement="auto"
                                                id="exam_id"
                                                name="exam_id"
                                                className="basic-select"
                                                classNamePrefix="select"
                                                options={getexamData.map(exam => ({
                                                    value: exam.examid,
                                                    label: exam.examtitle
                                                }))}
                                                onChange={handlExamChange}
                                                placeholder="Select an exam..."
                                            />
                                        </div>
                                        {examid && (
                                            <div className="text-center mt-5 mb-5">
                                                <p className="text-muted mb-3">Click the button below to download your registration form</p>
                                                <button
                                                    onClick={handleGeneratePDFNew}
                                                    disabled={isDownloading}
                                                    className={`btn btn-primary btn-lg px-4 py-2 ${isDownloading ? 'disabled' : ''}`}
                                                >
                                                    <i className="bi bi-download me-2"></i>
                                                    {isDownloading ? "Downloading..." : "Download Now"}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </StudentTemplate>
        </>
    );
};

export default ExamReg;